import React from "react";

import { Col, Row, Stack } from "react-bootstrap";

import classNames from "classnames";
import { startCase, toLower } from "lodash";

import { useGetResaleStatusHistoryByResaleIdQuery } from "@api/graphql";
import { DetailListTable } from "@components/DetailListTable";
import { Loading } from "@components/loading";
import styles from "@pages/dashboard/DetailsDrawer.module.scss";
import { formatISODateToFormat } from "@util/index";

interface ResaleStatusHistoryDrawerProps {
  resaleId: number;
}

export const ResaleStatusHistoryDrawer: React.FC<ResaleStatusHistoryDrawerProps> = ({ resaleId }) => {
  const { data, loading, error } = useGetResaleStatusHistoryByResaleIdQuery({
    variables: { resale_id: resaleId },
    skip: !resaleId,
  });

  const resaleStatusHistory = (data?.getResaleStatusHistoryByResaleId ?? []).filter(
    (record): record is Exclude<typeof record, undefined> => !!record,
  );

  return (
    <Stack gap={4} className="col-md-10">
      <Row>
        <span className={classNames(styles["stack-label"], "h5")}>Audit Trail</span>
      </Row>
      <Row>
        <Col>
          {loading ? (
            <Loading />
          ) : error ? (
            <div>Error loading status history</div>
          ) : (
            <DetailListTable
              data={resaleStatusHistory}
              headers={[
                {
                  label: "Status Change",
                  render: (record) => startCase(toLower(record.new_status)) || "-",
                },
                {
                  label: "Changed By",
                  render: (record) => `By ${record.changed_by || "Unknown"}`,
                },
                {
                  label: "Date",
                  render: (record) =>
                    record.change_date
                      ? formatISODateToFormat({ isoDate: record.change_date, targetDateFormat: "DD/MM/YYYY" })
                      : "-",
                },
              ]}
              rowKey={(record) => record.id}
            />
          )}
        </Col>
      </Row>
    </Stack>
  );
};
